// Fallback prices used when the Stripe pricing API is unreachable.
// These should match the latest known Stripe values.

export interface PlanPricing {
  id: string;
  name: string;
  monthlyPrice: number;
  annualPrice: number | null;
  monthlyEquivalent: number; // For annual: Math.round(annualPrice / 12)
  isAddOn: boolean;
  perUnit?: string; // e.g. "caregiver" for per-seat pricing
}

export const fallbackPrices: Record<string, PlanPricing> = {
  thrivemax: {
    id: 'thrivemax',
    name: 'Essential',
    monthlyPrice: 29,
    annualPrice: 299,
    monthlyEquivalent: 25,
    isAddOn: false,
  },
  thrivefamily: {
    id: 'thrivefamily',
    name: 'Family',
    monthlyPrice: 59,
    annualPrice: 599,
    monthlyEquivalent: 50,
    isAddOn: false,
  },
  'thrivecare-addon': {
    id: 'thrivecare-addon',
    name: 'Care Team Add-On',
    monthlyPrice: 15,
    annualPrice: null,
    monthlyEquivalent: 15,
    isAddOn: true,
    perUnit: 'caregiver',
  },
};
